@if (blockId) {
  <!--
    Keyed on blockId so the block-factory is destroyed/recreated when the id
    changes (BlockFactory only reads blockId in ngOnInit). Required for the CB2
    live preview, which swaps the render target to the pushed draft root.
  -->
  @for (id of [blockId]; track id) {
    <app-block-factory [blockId]="id"></app-block-factory>
  }
}
